import { GameClient, GameClientLoadingState } from '../gameClient/gameClient';
import { Localization } from '../localization/localization';
import { toastMessage } from '../../s/components/toast-message/toast-message';

export function getOpenAccountButton() {
    return $<HTMLButtonElement>('#account_button');
}

export function openWebglAccountWindow() {
    const gameClient = GameClient.getInstance();
    if (gameClient.getLoadingState() !== GameClientLoadingState.LOADED) {
        toastMessage.show(Localization._n('account.wait_for_client_to_load'));
    } else {
        GameClient.getJsToClientInterface().openAccountWindow();
    }
}

export function initAccountButton() {
    getOpenAccountButton().on('click', openWebglAccountWindow);
}
